import React from 'react'

function Footer() {
  return (
    <>
        <div className='footer'>
            <p>Created With ⚡ By Technical Sanket &copy;2022-23</p>
        </div>
    </>
  )
}

export default Footer;